import {ErrorMessage, Field, FieldArray, Form, Formik} from 'formik'
import React, {useEffect, useState} from 'react'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {Link, useNavigate} from 'react-router-dom'
import * as Yup from 'yup'
import {UserModel} from '../../../../app/modules/auth/models/UserModel'
import {RootState} from '../../../../setup'
import {StepNav1} from '../../../components/step-nav1'
import {OutwardInitValues, OutwardModel} from '../models/OutwardModel'
import * as MaterialIssuanceAction from '../../material-issuance/redux/MaterialIssuanceAction'
import * as DepartmentAction from '../../departments/redux/DepartmentAction'
import * as OutwardAction from '../redux/OutwardAction'
import {toast} from 'react-toastify'
import {Route, Breadcrumbs} from '../../../components/Breadcrumbs'
import Select from 'react-select'
import makeAnimated from 'react-select/animated'
import {DepartmentTableModelInitValues} from '../../departments/models/DepartmentModel'
type Props = {
  className: string
}

export const OutwardAdd: React.FC<Props> = ({className}) => {
  const [loading, setLoading] = useState(false)
  const materialIssuances: any = useSelector<RootState>(
    ({materialIssuance}) => materialIssuance.materialIssuances,
    shallowEqual
  )
  const [outward, setOutward] = useState<OutwardModel>(OutwardInitValues)
  const dispatch: any = useDispatch()
  let navigate = useNavigate()
  const animatedComponents = makeAnimated()

  const onChangeMaterialIssuance = (e: any, values: any) => {
    const selectedMaterialIssuance = materialIssuances.find(
      (materialIssuance: any) => materialIssuance._id === e.value
    )
    let uOutward = JSON.parse(JSON.stringify(values))
    if (selectedMaterialIssuance) {
      uOutward.materialIssuance = selectedMaterialIssuance?._id
      uOutward.providedToEmployee = selectedMaterialIssuance.providedToEmployee?._id
      uOutward.providedToDepartment = selectedMaterialIssuance.providedToDepartment?._id
      uOutward.location = selectedMaterialIssuance.location?._id
      uOutward.providedToEmployeeName = selectedMaterialIssuance.providedToEmployee?.fullName
      uOutward.providedToDepartmentName = selectedMaterialIssuance.providedToDepartment?.name
      uOutward.locationName = selectedMaterialIssuance.location?.name
      uOutward.items.shift()
      selectedMaterialIssuance.items.map((r: any, i: any) => {
        uOutward.items[i] = {
          _id: r._id,
          product: r.product,
          name: r.name,
          UOM: r.UOM,
          quantity: r.quantity,
          assetNumber: r.assetNumber,
          remarks: '',
        }
      })
      setOutward(uOutward)
    }
  }

  useEffect(() => {
    dispatch(MaterialIssuanceAction.fetchApproved())
    dispatch(DepartmentAction.fetchAll(DepartmentTableModelInitValues))
  }, [dispatch])

  let routes: Route[] = [
    {name: 'Dashboard', url: '/dashboard'},
    {name: 'Outwards List', url: '/outward'},
    {name: 'Outward Form', url: ''},
  ]

  return (
    <>
      <div className={`card card-custom ${className}`}>
        <Breadcrumbs routes={routes} />
        <div className='border-0 pt-5 p-5'>
          <StepNav1 itemNumber={3} />
        </div>
        <div className='card-header border-0 pt-5'>
          <h1 className='card-title'>
            <span className='card-label fw-bolder fs-3 mb-1'>Outward Form</span>
          </h1>
        </div>
        <div className='card-body py-10'>
          <Formik
            enableReinitialize
            initialValues={outward}
            validationSchema={Yup.object({
              materialIssuance: Yup.string().required('Material Issuance No is required'),
              items: Yup.array().of(
                Yup.object().shape({
                  name: Yup.string().required('Product is required'),
                  UOM: Yup.string().required('UOM is required'),
                  quantity: Yup.number()
                    .required('Quantity is required')
                    .typeError('Quantity is invalid')
                    .nullable()
                    .positive('Quantity must be more than 0'),
                  assetNumber: Yup.string().nullable(),
                  remarks: Yup.string()
                    .trim('Remarks must have non-empty spaces')
                    .strict(true)
                    .required('Remarks is required'),
                })
              ),
            })}
            onSubmit={(values: any) => {
              setLoading(true)
              dispatch(OutwardAction.create(values))
                .then((response: string) => {
                  toast.success(response)
                  setLoading(false)
                  navigate('/outward')
                })
                .catch((errorMsg: any) => {
                  toast.error(errorMsg)
                  setLoading(false)
                })
            }}
          >
            {({setFieldValue, values}) => (
              <Form>
                <div className='row row-cols-lg-2 row-cols-md-2 row-cols-1 g-5'>
                  <div className='form-group col' hidden>
                    <label htmlFor='providedToEmployee' className='fw-bold required'>
                      Provided To Employee Name
                    </label>
                    <Field
                      name='providedToEmployee'
                      className='form-control form-control-lg'
                      disabled={true}
                    />
                  </div>
                  <div className='form-group col' hidden>
                    <label htmlFor='providedToDepartment' className='fw-bold required'>
                      Provided To Department
                    </label>
                    <Field
                      name='providedToDepartment'
                      className='form-control form-control-lg'
                      disabled={true}
                    />
                  </div>
                  <div className='form-group col' hidden>
                    <label htmlFor='location' className='fw-bold required'>
                      Location
                    </label>
                    <Field
                      name='location'
                      className='form-control form-control-lg'
                      disabled={true}
                    />
                  </div>
                  <div className='form-group col'>
                    <label htmlFor='materialIssuance' className='fw-bold required'>
                      Material Issuance No.
                    </label>
                    <Select
                      options={
                        Array.isArray(materialIssuances)
                          ? materialIssuances?.map((materialIssuance: any, index: any) => {
                              return {
                                value: materialIssuance._id,
                                label: `${materialIssuance.number}`,
                                key: index,
                              }
                            })
                          : []
                      }
                      placeholder='Select'
                      className='multi-select-container'
                      classNamePrefix='multi-select'
                      name='materialRequisition'
                      onChange={(e: any) => {
                        if (e?.value) {
                          setFieldValue('materialIssuance', e.value)
                          onChangeMaterialIssuance(e, values)
                        } else {
                          setFieldValue('materialIssuance', '')
                        }
                      }}
                      closeMenuOnSelect={true}
                      isClearable={true}
                      components={animatedComponents}
                    />

                    {/* <Field
                      as='select'
                      className='form-select form-select-md'
                      data-control='select2'
                      name='materialIssuance'
                      onClick={(e: any) => onChangeMaterialIssuance(e, values)}
                    >
                      <option>Select</option>
                      {materialIssuances.map((materialIssuance: any, index: any) => (
                        <option value={materialIssuance._id} key={index}>
                          {materialIssuance.number}
                        </option>
                      ))}
                    </Field> */}
                    <div className='text-danger'>
                      <ErrorMessage name='materialIssuance' />
                    </div>
                  </div>
                  <div className='form-group col'>
                    <label htmlFor='providedToEmployeeName' className='fw-bold'>
                      Provided To Employee Name
                    </label>
                    <Field
                      name='providedToEmployeeName'
                      placeholder='Provided To Employee'
                      className='form-control form-control-lg'
                      disabled={true}
                    />
                  </div>
                  <div className='form-group col'>
                    <label htmlFor='providedToDepartmentName' className='fw-bold'>
                      Provided To Department
                    </label>
                    <Field
                      name='providedToDepartmentName'
                      placeholder='Provided To Department'
                      className='form-control form-control-lg'
                      disabled={true}
                    />
                  </div>
                  <div className='form-group col'>
                    <label htmlFor='locationName' className='fw-bold '>
                      Location
                    </label>
                    <Field
                      name='locationName'
                      placeholder='Location'
                      className='form-control form-control-lg'
                      disabled={true}
                    />
                  </div>
                </div>
                <FieldArray
                  name='items'
                  render={(arrayHelpers) => (
                    <div className='mt-15'>
                      <table className='table tbl-md-responsivness'>
                        <thead>
                          <tr>
                            <th>
                              <label className='form-label required'>Product</label>
                            </th>
                            <th>
                              <label className='form-label required'>UOM</label>
                            </th>
                            <th>
                              <label className='form-label required'>Quantity</label>
                            </th>
                            <th>
                              <label className='form-label'>Asset No.</label>
                            </th>
                            <th>
                              <label className='form-label required'>Remarks</label>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {values.items?.length > 0 &&
                            values.items?.map((materialItem: any, index: any) => (
                              <React.Fragment key={index}>
                                <tr>
                                  <td data-label='Product'>
                                    <div className='d-flex flex-column w-100'>
                                      <Field
                                        name={`items.${index}.name`}
                                        placeholder='Product'
                                        disabled={true}
                                        className='form-control form-control-md'
                                      />
                                      <div className='text-danger'>
                                        <ErrorMessage name={`items.${index}.name`} />
                                      </div>
                                    </div>
                                  </td>

                                  <td data-label='UOM'>
                                    <div className='d-flex flex-column w-100'>
                                      <Field
                                        name={`items.${index}.UOM`}
                                        placeholder='UOM'
                                        disabled={true}
                                        className='form-control form-control-md'
                                      />
                                      <div className='text-danger'>
                                        <ErrorMessage name={`items.${index}.UOM`} />
                                      </div>
                                    </div>
                                  </td>

                                  <td data-label='Quantity'>
                                    <div className='d-flex flex-column w-100'>
                                      <Field
                                        name={`items.${index}.quantity`}
                                        placeholder='Quantity'
                                        disabled={true}
                                        className='form-control form-control-md'
                                      />
                                      <div className='text-danger'>
                                        <ErrorMessage name={`items.${index}.quantity`} />
                                      </div>
                                    </div>
                                  </td>

                                  <td data-label='Asset No.'>
                                    <div className='d-flex flex-column w-100'>
                                      <Field
                                        name={`items.${index}.assetNumber`}
                                        placeholder='Asset No.'
                                        disabled={true}
                                        className='form-control form-control-md'
                                        maxLength={255}
                                      />
                                      <div className='text-danger'>
                                        <ErrorMessage name={`items.${index}.assetNumber`} />
                                      </div>
                                    </div>
                                  </td>

                                  <td data-label='Remarks'>
                                    <div className='d-flex flex-column w-100'>
                                      <Field
                                        name={`items.${index}.remarks`}
                                        placeholder='Remarks'
                                        className='form-control form-control-md'
                                        maxLength={255}
                                      />
                                      <div className='text-danger'>
                                        <ErrorMessage name={`items.${index}.remarks`} />
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </React.Fragment>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                />

                <div className='d-flex justify-content-end mt-10'>
                  <Link
                    to='/outward'
                    className='btn btn-lg btn-light-primary fw-bolder py-4 pe-8 me-3'
                    data-bs-toggle='tooltip'
                    data-bs-placement='top'
                    title='Cancel'
                  >
                    <span className='indicator-label'>Cancel</span>
                  </Link>

                  <button
                    type='submit'
                    className='btn btn-lg  btn-primary me-3'
                    data-bs-toggle='tooltip'
                    data-bs-placement='top'
                    title='Submit'
                    id='liveToastBtn'
                    disabled={loading}
                  >
                    <span className='indicator-label'>{loading ? 'Submitting...' : 'Submit'}</span>
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  )
}
